/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { Switch, Route } from 'react-router-dom';
import SympathyCremationFactsPage from './SympathyCremationFactsPage/SympathyCremationFactsPage';
import SympathyCustomerTestimonialsPage from './SympathyArticle/SympathyCustomerTestimonialsPage/SympathyCustomerTestimonialsPage';
import SympathyArticleGoodListenerPage from './SympathyArticleGoodListenerPage/SympathyArticleGoodListenerPage';
import SympathyArticlePage from './SympathyArticlePage/SympathyArticlePage';
import SympathyWhatsAppropriate from './SympathyWhatsAppropriate/SympathyWhatsAppropriateBlock';
import KosherSympathyPage from './KosherSympathyPage/KosherSympathyPage';
import SympathyFrequentlyAskedQuestionsPage from './SympathyFrequentlyAskedQuestionsPage/SympathyFrequentlyAskedQuestionsPage';
import SympathyFacebookWallPage from './SympathyFacebookWallPage/SympathyFacebookWallPage';
import SympathySandraWellWishes from './SympathySandraMagsamenWellWishes/SympathySandraWellWishesPage';

const SympathyPagesBuilder = ({ page }) => (
    <>
        <Switch>
            <Route exact path="/sympathy-cremation-facts" component={SympathyCremationFactsPage} />
            <Route exact path="/customer-testimonials-sympathy" component={SympathyCustomerTestimonialsPage} />
            <Route exact path="/sympathy-article-good-listener" component={SympathyArticleGoodListenerPage} />
            <Route
                exact
                path="/sympathy-articles"
                render={() => <SympathyArticlePage page={page} />}
            />
            <Route exact path="/Sympathy-Whats-Appropriate" component={SympathyWhatsAppropriate} />
            <Route exact path="/sympathy-400174557" component={KosherSympathyPage} />
            <Route exact path="/Sympathy-Commonly-Asked-Questions" component={SympathyFrequentlyAskedQuestionsPage} />
            <Route exact path="/sympathy-article-facebook-wall-condolence-note" component={SympathyFacebookWallPage} />
            <Route exact path="/sympathy-sandra-magsamen-well-wishes" component={SympathySandraWellWishes} />
        </Switch>
    </>
);

SympathyPagesBuilder.propTypes = {
    page: object.isRequired,
};

export default SympathyPagesBuilder;
